import type { ComponentProps, FunctionComponent, SVGProps } from 'react';

import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@mint-lib/tw-components';

type TabButtonProps = {
  Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  tooltip: string;
} & Partial<ComponentProps<typeof Button>>;

export const TabButton = ({ Icon, tooltip, ...props }: TabButtonProps) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild className="mb-2">
        <Button variant="text" {...props}>
          <Icon />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="left">{tooltip}</TooltipContent>
    </Tooltip>
  );
};
